import Screen from '../components/ui/Screen'
import TopBar from '../components/ui/TopBar'
import Panel from '../components/ui/Panel'
import texts from '../texts'

function Privacy() {
  return (
    <Screen bare>
      <TopBar title={texts.privacy.title} back="/" />

      <Panel>
        <b>{texts.privacy.dataStoredTitle}</b>
        <p className="text-[0.85em] text-text-2">{texts.privacy.dataStoredText}</p>
      </Panel>

      <Panel>
        <b>{texts.privacy.whereTitle}</b>
        <p className="text-[0.85em] text-text-2">{texts.privacy.whereText}</p>
      </Panel>

      <Panel>
        <b>{texts.privacy.emailTitle}</b>
        <p className="text-[0.85em] text-text-2">{texts.privacy.emailText}</p>
      </Panel>

      <Panel>
        <b>{texts.privacy.deleteTitle}</b>
        <p className="text-[0.85em] text-text-2">{texts.privacy.deleteText}</p>
      </Panel>

      <Panel>
        <b>{texts.privacy.contactTitle}</b>
        <p className="text-[0.85em] text-text-2">{texts.privacy.contactText}</p>
      </Panel>

      <Panel>
        <b>{texts.privacy.termsTitle}</b>
        <p className="text-[0.85em] text-text-2">{texts.privacy.termsText}</p>
      </Panel>
    </Screen>
  )
}

export default Privacy
